/*
 * Copyright (c) 2021 Mike Vo (info@miketvo.com) - All Rights Reserved.
 *
 * This file is part of the project "miketvo-website".
 *
 * This project is an online personal website by Mike Vo.
 *
 * COPYING AND/OR DISTRIBUTING OF ANY CONTENT WITHIN THIS PROJECT WITHOUT EX-
 * PRESS PERMISSION FROM THE CLIENT AND/OR THE AUTHOR, VIA ANY MEDIUM IS
 * STRICTLY PROHIBITED.
 *
 * Written by Mike Vo on June 27th 2021.
 *
 */

import * as React from "react";
import PropTypes from "prop-types";

const SetLang = ({ lang }) => {
  React.useEffect(() => {
    let currentLang = window.localStorage.getItem("lang");
    if (typeof window !== "undefined") {
      if (!currentLang || currentLang !== lang) window.localStorage.setItem("lang", lang);
    }
  }, []);

  return null;
};

SetLang.propTypes = {
  lang: PropTypes.string.isRequired,
};

export default SetLang;
